<template>
	<div class="tree-tabs">
		<a
			v-for="(item, index) in categories"
			:key="index"
			:class="['tree-tab-item', { active: activeIndex === index }]"
			href="javascript:void(0)"
			rel="nofollow"
			@click="onTap(item, index)"
		>
			{{ item.name }}
		</a>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	categories: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['orderTap']);

const activeIndex = ref(0);

function onTap(item, index) {
	activeIndex.value = index;
	emit('orderTap', item, index);
}

function tab(item, index) {
	if (item && typeof index === 'number') {
		activeIndex.value = index;
	}
}

watch(
	() => props.categories,
	list => {
		if (list?.length && activeIndex.value >= list.length) {
			activeIndex.value = 0;
		}
	},
	{ immediate: true }
);

defineExpose({ tab });
</script>

<style lang="scss" scoped>
.tree-tabs {
	width: 8.4rem;
	height: 100%;
	background: #f5f6f8;
	overflow-y: auto;
	.tree-tab-item {
		height: 2.5rem;
		display: block;
		line-height: 2.5rem;
		text-align: center;
		font-size: 0.93rem;
		color: #595959;
		background: transparent;
		width: 8.33333rem;
		height: 3.33333rem;
		color: #333333;
		line-height: 3.33333rem;
		font-size: 1.08333rem;
		padding: 0 0.66667rem;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		&.active {
			background: #fff;
			color: #455bd9;
			font-weight: 500;
			position: relative;
		}
		&.active::before {
			content: '';
			position: absolute;
			width: 0.33333rem;
			height: 1.16667rem;
			background: #455bd9;
			border-radius: 0 0.25rem 0.25rem 0;
			left: 0;
			top: 50%;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
		}
	}
}
</style>
